import React from "react";
import styled from "styled-components";
import Logo from "./Logo";
import { Link } from "react-router-dom"
import { FaPhone } from "react-icons/fa6";
import { MdMail } from "react-icons/md";
import "@fontsource/ibm-plex-mono";
import IconComponent from "./IconComponent";

const FooterWrapper = styled.div`
  width: 100%;
  margin: auto;
  background-color: #d9d9d9;
  color: #333;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  padding: 20px;
  @media (min-width: 768px) {
    padding: 20px 40px;
  }
`;

const FooterContainer = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-sizing: border-box;
  margin: auto;
  flex-direction: column;
  gap: 20px;
  
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    width: 25%;
  }
`;

const Tagline = styled.p`
  margin: 4px 0 0;
  font-size: 19px;
  color: #555;
  font-family: "IBM Plex Mono", Helvetica, monospace;
`;

const RightSection = styled.div`
  display: flex;
  gap: 20px;
`;

const FooterLink = styled.a`
  color: #333;
  text-decoration: none;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  margin-top:20px;

  &:hover {
    text-decoration: underline;
    color: #000;
  }
`;

const ColumnSection = styled.div`
  display: grid;
  row-gap: 10px;
  grid-template-columns: 1fr;

  @media (min-width: 480px) {
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
  }

  @media (min-width: 1024px) {
    column-gap: 50px;
  }
`;

const ContactContainer = styled.div``;

const ContactInfo = styled.a`
  color: #333;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  text-align: left;
  text-indent: 0; /* прибираємо щоб не було зсуву */
  text-decoration: none;
  display: flex;
  align-items: flex-start;
  gap: 8px; /* відстань між іконкою і текстом */
`;

const AddressInfo = styled.p`
  color: #333;
  font-family: "IBM Plex Mono", Helvetica, monospace;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  text-indent: 0; /* без відступу */
`;

const Copyright = styled.p`
  width: 100%;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;
  color: #333;
  font-family: "IBM Plex Mono", Helvetica, monospace;
`;

const Footer: React.FC = React.memo(() => {
  console.log("Розробник: Капустяк Анна");
  return (
    <FooterWrapper>
      <FooterContainer>
        <LeftSection>
          <Logo />
          <Tagline>Відкриємо світ Україні</Tagline>
        </LeftSection>
        <RightSection>
          <ColumnSection>
            <Link to={{pathname: "/delivery-conditions"}} style={{textDecoration: "none"}}>
                <FooterLink href="/delivery-conditions">Умови доставки</FooterLink>
            </ Link>
            <ContactContainer>
              <ContactInfo href="tel:+380507700967">
                <IconComponent icon={FaPhone} size={17} />
                  +38-050-770-09-67
                </ContactInfo>
            </ContactContainer>
            <Link to={{pathname: "/store-security"}} style={{textDecoration: "none"}}>
                <FooterLink href="/store-security">Безпека та захист даних</FooterLink>
            </ Link>
            <ContactContainer>
              <ContactInfo href="tel:+380977700967">
                <IconComponent icon={FaPhone} size={17} />
                +38-097-770-09-67
              </ContactInfo>
            </ContactContainer>
            <Link to={{pathname: "/terms-of-use"}} style={{textDecoration: "none"}}>
                <FooterLink href="/terms-of-use">Умови використання сайту</FooterLink>
            </Link>
            <ContactContainer>
              <ContactInfo href="tel:+380737700967">
                <IconComponent icon={FaPhone} size={17} />
                +38-073-770-09-67
              </ContactInfo>
            </ContactContainer>
            <AddressInfo>04200, м. Київ, вул. Дубровицька, 28</AddressInfo>

            <ContactContainer>
              <ContactInfo href="mailto:sales@barkovbooks.com">
                <IconComponent icon={MdMail} size={21.5}/>
                sales@barkovbooks.com
              </ContactInfo>
            </ContactContainer>
          </ColumnSection>
        </RightSection>
      </FooterContainer>
      <Copyright>
        © {new Date().getFullYear()} BarkovBooks. Усі права захищено.
      </Copyright>
    </FooterWrapper>
  );
});

export default Footer;
